export default {
    "name": "ChartDataQuery",
    "kind": "HoudiniQuery",
    "hash": "7bda4b0bba10e112782ab2dc1ec8a13b62a33863c724ed950e37507640cbad4b",

    "raw": `query ChartDataQuery($parameterSelectionList: [DashboardReportParametersInput], $dashboardReportId: Int!, $chartArgs: DashboardReportChartsArgs) {
  dashboardReport(parameters: $parameterSelectionList, id: $dashboardReportId) {
    id
    charts(args: $chartArgs) {
      chartId: id
      name
      title
      rank
      type
      supertype
      formatting
      json: jsonCombined
      dataTable {
        ... on GoogleDataTable {
          rows
          cols {
            id
            label
            type
            role
          }
        }
        ... on RactiveDataTable {
          columns {
            class
            name
            property
          }
          rows
        }
        __typename
      }
      multiSeries {
        value
        series
        tooltip
        groupXAxisBy
      }
      id
    }
    parameterValues {
      ... on DashboardReportDateParameter {
        name
        type
        title
        default
        value
      }
      ... on DashboardReportDateRangeParameter {
        name
        type
        title
        default
        value
        dates {
          from
          to
        }
      }
      ... on DashboardReportSelectionParameter {
        name
        type
        title
        default
        value
        optionList {
          id
          name
          fromQuery
          rawSql
        }
      }
      ... on DashboardReportSessionParameter {
        name
        type
        title
        default
        value
      }
      ... on DashboardReportSiteSelectionParameter {
        name
        type
        title
        default
        value
        permission
        optionList {
          id
          name
          fromQuery
        }
      }
      __typename
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "dashboardReport": {
                "type": "DashboardReport",
                "keyRaw": "dashboardReport(id: $dashboardReportId, parameters: $parameterSelectionList)",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "Int",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "charts": {
                            "type": "DashboardChart",
                            "keyRaw": "charts(args: $chartArgs)",

                            "selection": {
                                "fields": {
                                    "chartId": {
                                        "type": "Int",
                                        "keyRaw": "chartId",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "title": {
                                        "type": "String",
                                        "keyRaw": "title",
                                        "visible": true
                                    },

                                    "rank": {
                                        "type": "Int",
                                        "keyRaw": "rank",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "type": {
                                        "type": "String",
                                        "keyRaw": "type",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "supertype": {
                                        "type": "DashboardChartSupertype",
                                        "keyRaw": "supertype",
                                        "visible": true
                                    },

                                    "formatting": {
                                        "type": "String",
                                        "keyRaw": "formatting",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "json": {
                                        "type": "String",
                                        "keyRaw": "json",
                                        "visible": true
                                    },

                                    "dataTable": {
                                        "type": "DataTable",
                                        "keyRaw": "dataTable",
                                        "nullable": true,

                                        "selection": {
                                            "abstractFields": {
                                                "fields": {
                                                    "GoogleDataTable": {
                                                        "rows": {
                                                            "type": "String",
                                                            "keyRaw": "rows",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "cols": {
                                                            "type": "GoogleDataColumn",
                                                            "keyRaw": "cols",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "id": {
                                                                        "type": "String",
                                                                        "keyRaw": "id",
                                                                        "visible": true,
                                                                        "nullable": true
                                                                    },

                                                                    "label": {
                                                                        "type": "String",
                                                                        "keyRaw": "label",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "type": {
                                                                        "type": "String",
                                                                        "keyRaw": "type",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "role": {
                                                                        "type": "String",
                                                                        "keyRaw": "role",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        }
                                                    },

                                                    "RactiveDataTable": {
                                                        "columns": {
                                                            "type": "RactiveDataColumn",
                                                            "keyRaw": "columns",
                                                            "nullable": true,

                                                            "selection": {
                                                                "fields": {
                                                                    "class": {
                                                                        "type": "String",
                                                                        "keyRaw": "class",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "name": {
                                                                        "type": "String",
                                                                        "keyRaw": "name",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    },

                                                                    "property": {
                                                                        "type": "String",
                                                                        "keyRaw": "property",
                                                                        "nullable": true,
                                                                        "visible": true
                                                                    }
                                                                }
                                                            },

                                                            "visible": true
                                                        },

                                                        "rows": {
                                                            "type": "String",
                                                            "keyRaw": "rows",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "__typename": {
                                                            "type": "String",
                                                            "keyRaw": "__typename",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "typeMap": {}
                                            },

                                            "fields": {
                                                "__typename": {
                                                    "type": "String",
                                                    "keyRaw": "__typename",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "abstract": true,
                                        "visible": true
                                    },

                                    "multiSeries": {
                                        "type": "DashboardChartMultiSeries",
                                        "keyRaw": "multiSeries",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "value": {
                                                    "type": "String",
                                                    "keyRaw": "value",
                                                    "visible": true
                                                },

                                                "series": {
                                                    "type": "String",
                                                    "keyRaw": "series",
                                                    "visible": true
                                                },

                                                "tooltip": {
                                                    "type": "String",
                                                    "keyRaw": "tooltip",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "groupXAxisBy": {
                                                    "type": "String",
                                                    "keyRaw": "groupXAxisBy",
                                                    "visible": true
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "Int",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "parameterValues": {
                            "type": "DashboardReportParameter",
                            "keyRaw": "parameterValues",

                            "selection": {
                                "abstractFields": {
                                    "fields": {
                                        "DashboardReportDateParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        },

                                        "DashboardReportDateRangeParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "dates": {
                                                "type": "DashboardReportDateRangeParameterDates",
                                                "keyRaw": "dates",
                                                "nullable": true,

                                                "selection": {
                                                    "fields": {
                                                        "from": {
                                                            "type": "String",
                                                            "keyRaw": "from",
                                                            "visible": true
                                                        },

                                                        "to": {
                                                            "type": "String",
                                                            "keyRaw": "to",
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        },

                                        "DashboardReportSelectionParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "optionList": {
                                                "type": "OptionListEntry",
                                                "keyRaw": "optionList",

                                                "selection": {
                                                    "fields": {
                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true,
                                                            "nullable": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "fromQuery": {
                                                            "type": "Boolean",
                                                            "keyRaw": "fromQuery",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "rawSql": {
                                                            "type": "Boolean",
                                                            "keyRaw": "rawSql",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        },

                                        "DashboardReportSessionParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        },

                                        "DashboardReportSiteSelectionParameter": {
                                            "name": {
                                                "type": "String",
                                                "keyRaw": "name",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "type": {
                                                "type": "DashboardReportParameterType",
                                                "keyRaw": "type",
                                                "visible": true
                                            },

                                            "title": {
                                                "type": "String",
                                                "keyRaw": "title",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "default": {
                                                "type": "String",
                                                "keyRaw": "default",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "value": {
                                                "type": "String",
                                                "keyRaw": "value",
                                                "visible": true
                                            },

                                            "permission": {
                                                "type": "String",
                                                "keyRaw": "permission",
                                                "nullable": true,
                                                "visible": true
                                            },

                                            "optionList": {
                                                "type": "OptionListEntry",
                                                "keyRaw": "optionList",

                                                "selection": {
                                                    "fields": {
                                                        "id": {
                                                            "type": "String",
                                                            "keyRaw": "id",
                                                            "visible": true,
                                                            "nullable": true
                                                        },

                                                        "name": {
                                                            "type": "String",
                                                            "keyRaw": "name",
                                                            "nullable": true,
                                                            "visible": true
                                                        },

                                                        "fromQuery": {
                                                            "type": "Boolean",
                                                            "keyRaw": "fromQuery",
                                                            "nullable": true,
                                                            "visible": true
                                                        }
                                                    }
                                                },

                                                "visible": true
                                            },

                                            "__typename": {
                                                "type": "String",
                                                "keyRaw": "__typename",
                                                "visible": true
                                            }
                                        }
                                    },

                                    "typeMap": {}
                                },

                                "fields": {
                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                }
                            },

                            "abstract": true,
                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "parameterSelectionList": "DashboardReportParametersInput",
            "dashboardReportId": "Int",
            "chartArgs": "DashboardReportChartsArgs"
        },

        "types": {
            "DashboardReportRangeInput": {
                "from": "String",
                "to": "String"
            },

            "DashboardReportOptionListInput": {
                "id": "String",
                "name": "String"
            },

            "DashboardReportParametersInput": {
                "dates": "DashboardReportRangeInput",
                "name": "String",
                "optionList": "DashboardReportOptionListInput",
                "permission": "String",
                "value": "String"
            },

            "DashboardReportChartsArgs": {
                "hidden": "Boolean",
                "id": "Int",
                "inReport": "Boolean"
            }
        },

        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=186f657713def5a2c3875ac1798c3f997debe2fed8b11052b97264024c0b766d";